import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { LastStudyData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import LoadingErrorState from './LoadingErrorPanel';
import { LAST_STUDY, PAGE, AI_SUMMARY_DISCLAIMER } from '../../../constants';
import { isMobile } from '../../../utils/util';

interface LastStudyPanelProps {
  data: LastStudyData;
  isOpen: boolean;
  onClose: () => void;
}

export default function LastStudyPanel({
  data,
  isOpen,
  onClose,
}: LastStudyPanelProps) {
  const cx = classNames.bind(styles);
  const { bookTitle, bookCover, page, status, description } = data;

  const hasContent = status === 1 && description;
  const isLoading = status === 2;
  const isError = status === 3;

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader
        cardId="last-learning"
        title={LAST_STUDY}
        isBeta
        onClose={onClose}
      />
      <div className={cx('widget_content', 'study')}>
        {bookCover && !isMobile && (
          <div className={cx('study_img')}>
            <img src={bookCover} alt={bookTitle} />
          </div>
        )}
        <div className={cx('study_info')}>
          <div className={cx('study_info_title')}>
            <div className={cx('study_info_title_wrap')}>
              <span className={cx('book_name')}>{bookTitle}</span>
              {/* TODO: 조사 처리 유틸리티 추가 */}
              <span>의</span>
            </div>
            <span className={cx('read_page')}>
              {page}
              {PAGE}
            </span>
          </div>
          {isLoading || isError ? (
            <LoadingErrorState isLoading={isLoading} isError={isError} />
          ) : (
            hasContent && (
              <>
                <p className={cx('study_desc')}>{description}</p>
                <span className={cx('subtext')}>※ {AI_SUMMARY_DISCLAIMER}</span>
              </>
            )
          )}
        </div>
      </div>
    </PanelContainer>
  );
}
